// Event.js

import React, { Component } from 'react';
//import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import axios from 'axios';
import Form from "react-jsonschema-form";
import JSONSchemaForm from "react-jsonschema-form";
import { connect } from 'react-redux';
import { updateAlert } from '../actions/alert-actions';
import moment from 'moment';

class AdminEvent extends Component {
  state = {
    event: [],
    Form: JSONSchemaForm.default,
    jsonSchema: {
      "title": "Administer Booking",
      "description": "Edit this booking",
      "type": "object",
      "required": [
        "start",
        "end",
        "type"
      ],
      "properties": {
        "type": {
          "type": "string",
          "title": "Event Type",
          "enum"  : ['Reservation', 'Practice', 'Game', 'Camp', 'Zamboni', 'Closure']
        },
        "start": {
          "type": "string",
          "title": "Start Time"
        },
        "end": {
          "type": "string",
          "title": "End Time"
        }
      },
      "dependencies": {
        "type": {
          "oneOf": [
            {
              "properties": {
                "type": {
                  "enum": [
                    "Closure"
                  ]
                },
                "title": {
                  "type": "string",
                  "title": "Reservation Title",
                  "default": "Closed - "
                }
              },
              "required": [
                "title"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Zamboni"
                  ]
                },
                "title": {
                  "type": "string",
                  "title": "Reservation Title",
                  "default": "Zamboni"
                }
              },
              "required": [
                "title"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Reservation"
                  ]
                },
                "title": {
                  "type": "string",
                  "title": "Reservation Title",
                },
                "notes": {
                  "type": "string",
                  "title": "Additional Information/Comments"
                }
              },
              "required": [
                "title"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Camp"
                  ]
                },
                "title": {
                  "type": "string",
                  "title": "Camp Name",
                },
                "notes": {
                  "type": "string",
                  "title": "Additional Information/Comments"
                }
              },
              "required": [
                "title"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Game"
                  ]
                },
                "home_team": {
                  "type": "string",
                  "title": "Home Team",
                  "default": "BMHA"
                },
                "away_team": {
                  "type": "string",
                  "title": "Away Team",
                  "default": "TBD"
                },
                "refs": {
                  "type": "boolean",
                  "title": "Refs Required"
                },
                "divider": {
                  "type": "boolean",
                  "title": "Half-ice Divider"
                },
                "title": {
                  "type": "string",
                  "title": "Camp Name",
                },
                "notes": {
                  "type": "string",
                  "title": "Additional Information/Comments"
                }
              },
              "required": [
                "home_team",
                "away_team"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Practice"
                  ]
                },
                "home_team": {
                  "type": "string",
                  "title": "Team",
                  "default": "BMHA"
                },
                "title": {
                  "type": "string",
                  "title": "Practice Name",
                  "readOnly": true
                },
                "notes": {
                  "type": "string",
                  "title": "Additional Information/Comments"
                }
              },
              "required": [
              ]
            }
          ]
        }
      }
    },
    uiSchema: {
      "type": {
        "ui:autofocus": true,
        "ui:widget": "select"
      },
      "age": {
        "ui:widget": "select"
      },
      "notes": {
        "ui:widget": "textarea",
 //       "ui:help": "Hint: Make it strong!"
      },
      "start": {
        "ui:widget": "date-time"
      },
      "end": {
        "ui:widget": "date-time"
      }
    },
      roomJsonSchema: {
      "title": "Assign Dressing Rooms",
      "description": "Assign Rooms fo this event",
      "type": "object",
      "required": [
        "home_room",
        "away_room"
      ],
      "properties": {
        "home_room": {
          "type": "integer",
          "title": "Home Room",
          "enum": [0, 1, 2, 3, 4],
          "enumNames"  : ['None', 'Room 1', 'Room 2', 'Room 3', 'Room 4']
        },
        "away_room": {
          "type": "integer",
          "title": "Away Room",
          "enum": [0, 1, 2, 3, 4],
          "enumNames"  : ['None', 'Room 1', 'Room 2', 'Room 3', 'Room 4']
        }
      }
    },
    roomUiSchema: {
      "home_room": {
        "ui:autofocus": true,
        "ui:widget": "select"
      },
      "away_room": {
        "ui:widget": "select"
      },
    }
  }

  onSubmitRooms(formData) {
    console.log("rooms", formData.formData);
    var response = fetch('https://beisekerice.com/api/v0/events/' + this.props.match.params.id + '/rooms', {
    //  var response = fetch('http://localhost:3001/api/v0/events/' + this.props.match.params.id + '/rooms', {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + this.props.user.token
      },
      body: JSON.stringify(formData.formData)
    }).then(response => {
      if (!response.ok) {
          console.log(response.statusText);
          return Promise.reject(response.statusText);
      }
      console.log(response.statusText);
      this.props.history.push(`/admin`);
  })
  .catch(error => {
    console.log(error);
    this.props.onUpdateAlert("Unable to set rooms");
  });
  }

  onSubmitEvent(formData) {
    formData.formData.start = new moment(formData.formData.start).format('YYYY-MM-DDTHH:mm:ss')
    formData.formData.end = new moment(formData.formData.end).format('YYYY-MM-DDTHH:mm:ss')
    console.log("update event", formData.formData);
    var response = fetch('https://beisekerice.com/api/v0/events/' + this.props.match.params.id, {
    //  var response = fetch('http://localhost:3001/api/v0/events/' + this.props.match.params.id, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + this.props.user.token
      },
      body: JSON.stringify(formData.formData)
    }).then(response => {
      if (!response.ok) {
          console.log(response.statusText);
          return Promise.reject(response.statusText);
      }
      console.log(response.statusText);
      this.props.history.push(`/admin`);
  })
  .catch(error => {
    console.log(error);
    this.props.onUpdateAlert("Unable update event");
  });
  }

  onDeleteEvent() {
    console.log("delete event", this.props.match.params.id);
    var response = fetch('https://beisekerice.com/api/v0/events/' + this.props.match.params.id, {
    //  var response = fetch('http://localhost:3001/api/v0/events/' + this.props.match.params.id, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + this.props.user.token
      }
    }).then(response => {
      if (!response.ok) {
          console.log(response.statusText);
          return Promise.reject(response.statusText);
      }
      console.log(response.statusText);
      this.props.history.push(`/admin`);
  })
  .catch(error => {
    console.log(error);
    this.props.onUpdateAlert("Unable delete event");
  });
  }

  componentDidMount() {
    axios.get("https://beisekerice.com/api/v0/events/"+this.props.match.params.id)
      .then(res => {
        const event = res.data;
        this.setState({ event });
      })
  }

  render() {

    return (
        <div class="contentView">
                  <div className="container">
            <div className="col-sm-6 offset-sm-3 mt-2">
                {this.props.alert &&
                    <div className={'alert alert-warning'}>{this.props.alert}</div>
                }
            </div>
        </div>
          <h2>Event</h2>
          <Form schema={this.state.jsonSchema}
            className="form form-wide"
            uiSchema={this.state.uiSchema}
            onSubmit={this.onSubmitEvent.bind(this)} 
            formData={this.state.event} />
          <p>Title: { this.state.event.title }</p>
          <p>Start:  <Moment format="YYYY/MM/DD hh:mm a" date={this.state.event.start} /></p>
          <p>End: <Moment format="YYYY/MM/DD hh:mm a" date={this.state.event.end} /></p>
          <p>Duration: <Moment diff={this.state.event.start} unit="hours" decimal>{this.state.event.end}</Moment> hour(s)</p>
          <p>Type: { this.state.event.type }</p>

          <div>
          <Form schema={this.state.roomJsonSchema}
            className="form form-wide"
            uiSchema={this.state.roomUiSchema}
            onSubmit={this.onSubmitRooms.bind(this)} />
          <div>
          <button className='btn btn-info' onClick={this.props.history.goBack}>Back</button></div>
          <div><button className='btn btn-info' onClick={this.onDeleteEvent.bind(this)}>Delete Event</button></div>
          </div>
        </div>
    );
  }
}


const mapStateToProps = state => ({
  cart: state.cart,
  user: state.user,
  alert: state.alert
});

const mapActionsToProps = {
  onUpdateAlert: updateAlert
};

export default connect(mapStateToProps, 
  mapActionsToProps
  )(AdminEvent);


// WEBPACK FOOTER //
// ./src/components/AdminEvent.js